import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { DashboardSummary } from '../models/dashboard.model';

@Injectable({
  providedIn: 'root',
})
export class DashboardApiService {
  private readonly http = inject(HttpClient);
  private readonly api = environment.apiUrl.replace(/\/$/, '');

  getDashboardSummary(fromUtc: string, toUtc: string, refreshTimestamp?: number): Observable<DashboardSummary> {
    let params = new HttpParams().set('fromUtc', fromUtc).set('toUtc', toUtc);
    if (refreshTimestamp !== undefined) {
      params = params.set('refreshTimestamp', String(refreshTimestamp));
    }

    return this.http.get<DashboardSummary>(`${this.api}/dashboard/summary`, { params });
  }
}
